<template>
  <div class="container">
    <scatterchart v-if="loaded" :chartdata="chartdata" :options="options" :height="150"/>
  </div>
</template>

<script>
import ScatterChart from "./ScatterChart.js";
import { API } from "aws-amplify";

export default {
  name: "ScatterChartContainer",
  components: {
    scatterchart: ScatterChart
  },
  props: ["collection_type", "user", "chart_id", "label", "reflines", "linear", "refpoint", "units", "color", "scale"],
  data: () => ({
    loaded: false,
    chartdata: null,
    maindata: null,
    type: "scatter",
    options: {
      legend: {
        position: "top",
        align: "start"
      },
      scales: {
        xAxes: [
          {
            type: "logarithmic",
            ticks: {
              beginAtZero: true,
              /* callback: value => Number(value).toLocaleString() */ 
              callback: function (value, index, values) {
                  if (value === 1000000) return "1,000,000";
                   if (value === 100000) return "100,000";
                   if (value === 10000) return "10,000";
                   if (value === 1000) return "1,000";
                   if (value === 100) return "100";
                   if (value === 10) return "10";
                   if (value === 0) return "0";
                   // if (value === 500000) return "500TB";
                   // if (value === 50000) return "50TB";
                   // if (value === 5000) return "5TB";
                   // if (value === 500) return "500";
                   // if (value === 50) return "50";
                   // if (value === 5) return "5";
                   // if (value === 4) return "3";
                   // if (value === 3) return "3";
                   // if (value === 2) return "2";
                   if (value === 1) return "1";
                   if (value === 0.1) return "0.1";
                   if (value === 0.01) return "0.01";
                   return null;
                }
            }
          }
        ],
                yAxes: [
          {
            type: "linear",
            scaleLabel: {
              display: true,
              labelString: 'percentile'
            },
            ticks: {
              beginAtZero: true,
              /* callback: value => Number(value).toLocaleString() */ 
              callback: function (value, index, values) {
                   if (value === 100) return "100";
                   if (value === 50) return "50";
                   if (value === 0) return "0";
                  return null;
                }
            }
          }
        ]
  
      },
      responsive: true,
      subtitles: [],
      maintainAspectRatio: false,
      annotation: {
        annotations: [
/*          {
            type: 'line',
            mode: 'vertical',
            scaleID: 'x-axis-1',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              yAdjust: 220,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: 'Max'
            }
          },
          {
            type: 'line',
            mode: 'vertical',
            scaleID: 'x-axis-1',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              yAdjust: 180,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '99%'
            }
          },
          {
            type: 'line',
            mode: 'vertical',
            scaleID: 'x-axis-1',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              yAdjust: 140,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '95%'
            }
          },
          {
            type: 'line',
            mode: 'vertical',
            scaleID: 'x-axis-1',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              yAdjust: 100,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '90%'
            }
          }, */
          // {
          //   type: 'line',
          //   mode: 'vertical',
          //   scaleID: 'x-axis-1',
          //   value: 4.5,
          //   borderColor: 'grey',
          //   borderWidth: 2,
          //   label: {
          //     enabled: true,
          //     position: "left",
          //     yAdjust: 20,
          //     content: 'Avg',
          //     xPadding: 4,
          //     yPadding: 4,
          //     cornerRadius: 4,
          //     backgroundColor: 'grey'
          //   }
          // },
          {
            type: 'line',
            mode: 'vertical',
            scaleID: 'x-axis-1',
            value: 4,
            borderColor: 'grey',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 0,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: 'Median',
              backgroundColor: 'grey'
            }
          }

        ]
      }
      
    }
  }),
  async mounted() {
    this.loaded = false;
    try {
      // console.log("SCC: I am here");
      let sorted = [];
      let total_val = 0;
      let current_val = 0;
      
      var tries = 2;
      while (tries > 0) {
        await API.get("dbcsiAPI", `/dbcsi/summary/${this.collection_type}/${this.chart_id}`)
          .then(response => {
            // console.log("SCC: I am here3");
              this.maindata = response.data;
              
              this.newdata = [];

              for (var ii = 0; ii < this.maindata.length; ii++) {
                // console.log(this.maindata[ii].y*1);
                this.newdata.push({
                  /* x: this.maindata[ii].y, */ x: this.maindata[ii].y*1, y: Math.round(100*10*(this.maindata.length-ii)/this.maindata.length)/10
                  /* y: this.maindata[ii].x */
                }); //Note: we are flipping x and y because I want this be a horizontal-looking chart 
             
                //calculate statistics
                  current_val=Number(this.maindata[ii].y*1);
               total_val = total_val + current_val;
                sorted.push(current_val);
              }

              tries = 0;
            // console.log(this.maindata);
          })
          .catch(error => {
            console.log("SCC Error:", error);
          });
        tries -= 1;
      }

      this.chartdata = {
        datasets: [
          {
            label: this.label,
            data:  this.newdata ,
            borderColor: this.color,
            backgroundColor: this.color,
            borderWidth: 2,
            pointRadius: 1,            
            fill: false 
          }
        ]
      };
      
      
      

   if(this.maindata.length==0) {
     // console.log("chartid",this.chart_id, this.maindata.length);
     this.chartdata.datasets[0].label = "No data-- next time, use latest version of DBCSI data collection script" ;
   }
  	
      //calculate statistics
      //sort values
      //calculate median and percentiles
      sorted.sort(function(a, b){return a-b});

      // console.log("chartid",this.chart_id, sorted);
      
      let pctl90 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*90/100))];
      let pctl95 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*95/100))];
      let pctl99 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*99/100))];
      let pctl50 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*50/100))];
      let pctlmax = sorted[sorted.length-1];
      let pctlavg = (total_val/sorted.length);
      
      //console.log (total_val);
      
      //update annotations
      this.options.annotation.annotations[0].value = pctl50;
      this.options.annotation.annotations[0].label.content = "Median: "+Math.round(pctl50*this.scale)/this.scale+" "+this.units; 
      // this.options.annotation.annotations[0].value = pctlavg;
      // this.options.annotation.annotations[0].label.content = "Avg: "+Math.round(pctlavg*this.scale)/this.scale+" "+this.units;
      if (this.refpoint*1 > 0) {
        // console.log("Your Database: "+Math.round(this.refpoint*this.scale)/this.scale+" "+this.units, sorted.length);
        this.options.annotation.annotations[1] =  {
            type: 'line',
            mode: 'vertical',
            scaleID: 'x-axis-1',
            value: this.refpoint*1,
            borderColor: this.color,
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              yAdjust: -20,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: "Your Database: "+Math.round(this.refpoint*this.scale)/this.scale+" "+this.units,
              backgroundColor: this.color
            }  
          };  
      }  
      /* this.options.annotation.annotations[3].value = pctl90;
      this.options.annotation.annotations[3].label.content = "90%: "+Math.round(pctl90*scale)/scale;
      this.options.annotation.annotations[2].value = pctl95;
      this.options.annotation.annotations[2].label.content = "95%: "+Math.round(pctl95*scale)/scale;
      this.options.annotation.annotations[1].value = pctl99;
      this.options.annotation.annotations[1].label.content = "99%: "+Math.round(pctl99*scale)/scale;
      this.options.annotation.annotations[0].value = pctlmax;
      this.options.annotation.annotations[0].label.content = "Max: "+Math.round(pctlmax*scale)/scale; */
      //done
    
     // console.log(this.reflines);  
     if ((this.reflines==false) || (this.reflines=="false")) {
       console.log("reflines is false");
       this.options.annotation = {};
     }  
      
     if ((this.linear==true) || (this.linear=="true")) {
       // console.log("linear is true");
       this.options.scales.xAxes[0].type="linear";
       this.options.scales.xAxes[0].ticks={beginAtZero: true};
     }  else {
       if (this.units == "GB") {
            this.options.scales.xAxes[0].ticks.callback = function (value, index, values) {
                   if (value === 1000000) return "1PB";
                   if (value === 100000) return "100TB";
                   if (value === 10000) return "10TB";
                   if (value === 1000) return "1TB";
                   if (value === 100) return "100GB";
                   if (value === 10) return "10GB";
                   if (value === 0) return "0";
                   // if (value === 500000) return "500TB";
                   // if (value === 50000) return "50TB";
                   // if (value === 5000) return "5TB";
                   // if (value === 500) return "500";
                   // if (value === 50) return "50";
                   // if (value === 5) return "5";
                   // if (value === 4) return "3";
                   // if (value === 3) return "3";
                   // if (value === 2) return "2";
                   if (value === 1) return "1GB";
                   if (value === 0.1) return "0.1";
                   if (value === 0.01) return "0.01";
                
                   return null;
            }
       }  
     }
      
      this.loaded = true;
    } catch (e) {
      console.error(e);
    }
  }
};
</script>